// SPDX-FileCopyrightText: 2023 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from 'store/hooks';
import { toggleCreateDialog } from 'store/reducers/projectSettingsSlice';
import useAppPermissions from 'hooks/useAppPermissions';
import { Button } from '@tls/treact-ui';
import { IconPlus } from '@tls/treact-ui/icons';

export default function AddProjectButton() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const { hasCreateCDProjectPermission, hasCreateQCProjectPermission } = useAppPermissions();

  const onClick = useCallback(() => dispatch(toggleCreateDialog()), [dispatch]);

  return (
    <Button
      icon={<IconPlus />}
      onClick={onClick}
      className='fill'
      label={t('projects.addNewProject')}
      disabled={!hasCreateCDProjectPermission && !hasCreateQCProjectPermission}
      data-testid='projects-create-button'
    />
  );
}
